import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ItemChildrenActions } from './item-children.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { ItemDetailAsyncActions } from './item-children.actions';
import {ChildItemGrouping} from '@emm/core/models/item-summary.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const itemChildrenFeatureKey = 'itemChildren';

export interface ItemChildrenState extends EntityState<ChildItemGrouping>, AsyncActionState {}

export const adapter: EntityAdapter<ChildItemGrouping> = createEntityAdapter<ChildItemGrouping>({
    selectId: (grouping: ChildItemGrouping) => grouping.path,
    sortComparer: null
});

export const initialState: ItemChildrenState = adapter.getInitialState({
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = ItemDetailAsyncActions;

export const itemChildrenReducer = withLoadables<ItemChildrenState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, () => ({
        ...initialState,
    })),

    on(ItemChildrenActions.loadSuccess, (state: ItemChildrenState, { items, path }) =>
        adapter.upsertOne({ path, items }, state)
    )

);
